<span class="{{className}}">{{ timeLeft | timestampToTime }}</span>